export default function swDev(): void {
  // In Vite, public files are served from root — no PUBLIC_URL needed
  const swUrl = `/sw.js`;

  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.warn('✅ Service Worker registered successfully:', registration);

      // Check for updates every 60 seconds (or on page focus)
      setInterval(() => {
        registration.update();
      }, 60000);

      // Listen for new service worker updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;

        newWorker?.addEventListener('statechange', () => {
          if (
            newWorker.state === 'installed' &&
            navigator.serviceWorker.controller
          ) {
            // New service worker available, prompt user to refresh
            // Auto-reload after a short delay to apply updates
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        });
      });

      // Handle controller change (when new SW takes over)
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
      });
    })
    .catch((error) => {
      console.error('❌ Service Worker registration FAILED:', error);
      console.error('Error details:', {
        message: error.message,
        name: error.name,
        stack: error.stack,
      });
      // Don't let SW registration failure break the app
      // The app should still work without Service Worker (online only)
    });
}
